import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-clock\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16C3.582 16 0 12.418 0 8C0 3.582 3.582 0 8 0C12.418 0 16 3.582 16 8C16 12.418 12.418 16 8 16ZM8 2C4.686 2 2 4.686 2 8C2 11.314 4.686 14 8 14C11.314 14 14 11.314 14 8C14 4.686 11.314 2 8 2ZM11 9H8C7.448 9 7 8.552 7 8V5C7 4.448 7.448 4 8 4C8.552 4 9 4.448 9 5V7H11C11.552 7 12 7.448 12 8C12 8.552 11.552 9 11 9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol